import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { ArrowRight, Award } from 'lucide-react';
import { mockData } from '../../data/mock';
import { Reveal } from './Reveal';

export const PhilosophySection = () => (
  <section className="section-spacing bg-cream">
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
        <Reveal className="md:col-span-5">
          <div className="relative">
            <div className="aspect-[4/5] rounded-[2rem] overflow-hidden bg-light-blue/30 shadow-xl">
              <img
                src="/makhan-diallo.jpg"
                alt="Makhan DIALLO, fondateur et expert-comptable de MMD CONSEIL"
                className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
              />
            </div>
            <div className="absolute -bottom-5 left-6 bg-white rounded-2xl shadow-lg px-5 py-3 border border-border-soft flex items-center gap-3">
              <Award className="w-5 h-5 text-warm-accent" />
              <span className="text-sm font-medium text-primary-blue">Diplômé DEC</span>
            </div>
          </div>
        </Reveal>

        <Reveal className="md:col-span-7" delay={120}>
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-warm-accent mb-4">Notre philosophie</p>
          <h2 className="font-heading text-3xl md:text-5xl font-light tracking-tight text-primary-blue mb-6">
            Plus qu’un comptable, un véritable copilote
          </h2>
          <p className="text-text-gray text-lg leading-relaxed mb-4">
            Chez MMD CONSEIL, nous croyons que la comptabilité n’est pas une fin en soi, mais un point de départ.
            Derrière chaque chiffre se cache une décision à prendre, un projet à sécuriser, une ambition à concrétiser.
          </p>
          <p className="text-text-gray leading-relaxed mb-10">
            Fondé par <strong className="text-text-dark">Makhan DIALLO</strong>, expert-comptable diplômé DEC fort de plus de 10 ans
            d’expérience, le cabinet met l’humain et le conseil au cœur de l’accompagnement des entrepreneurs et PME.
          </p>

          <div className="space-y-5 mb-10">
            {mockData.valeurs.map((valeur) => (
              <div key={valeur.titre} className="border-l-2 border-warm-accent pl-5">
                <h3 className="font-heading text-lg font-medium text-primary-blue mb-1">{valeur.titre}</h3>
                <p className="text-text-gray text-sm leading-relaxed">{valeur.description}</p>
              </div>
            ))}
          </div>

          <Button asChild variant="outline" className="rounded-full border-primary-blue text-primary-blue hover:bg-primary-blue hover:text-white px-7 py-5">
            <Link to="/a-propos" data-testid="philosophy-cta-about" className="flex items-center gap-2">
              Découvrir le cabinet
              <ArrowRight className="w-4 h-4" />
            </Link>
          </Button>
        </Reveal>
      </div>
    </div>
  </section>
);
